import { render, staticRenderFns } from "./InnerPageTitle.vue?vue&type=template&id=572c5c35&"
import script from "./InnerPageTitle.vue?vue&type=script&lang=js&"
export * from "./InnerPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports